import React from "react";

const FilledChevronUp = ({ size = 12, color = "#ccc" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 8l6 6H6l6-6z" />
  </svg>
);

const FilledChevronDown = ({ size = 12, color = "#ccc" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 16l-6-6h12l-6 6z" />
  </svg>
);

const SortableHeader = ({ label, field, sortField, sortOrder, handleSort }) => {
  return (
    <th onClick={() => handleSort(field)} style={{ cursor: "pointer" }}>
      <span
        style={{
          display: "flex",
          alignItems: "center",
          gap: 4,
          fontFamily: "Montserrat",
          fontSize: "12px",
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "normal",
          color: "var(--Gray-900, #212529)",
        }}
      >
        {label}
        <span style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
          <div style={{ lineHeight: 0 }}>
            <FilledChevronUp
              size={12}
              color={sortField === field && sortOrder === "asc" ? "black" : "#6C757D"}
            />
          </div>
          <div style={{ lineHeight: 0, marginTop: -12}}>
            <FilledChevronDown
              size={12}
              color={sortField === field && sortOrder === "desc" ? "black" : "#6C757D"}
            />
          </div>
        </span>
      </span>
    </th>
  );
};

export default SortableHeader;